import { isPlatformBrowser } from '@angular/common'
import { inject, Injectable, PLATFORM_ID } from '@angular/core'
import { CanActivate, Router, UrlTree } from '@angular/router'

import { OktaAuthService } from 'app/_shared/services/okta-auth.service'
import { UserStore } from 'app/store/user.store'

@Injectable({
  providedIn: 'root'
})
export class OktaCallbackGuard implements CanActivate {
  private router = inject(Router)
  private userStore = inject(UserStore)
  private oktaAuthService = inject(OktaAuthService)
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID))

  canActivate(): boolean | UrlTree {
    if (!this.isBrowser || this.oktaAuthService.isLoginRedirect()) {
      return true
    }

    return this.userStore.isLoggedIn()
      ? this.router.createUrlTree(['/'])
      : this.router.createUrlTree(['/login'])
  }
}
